import { FC, memo } from 'react';

import {
  ContextMenuTooltip,
  IContextMenuTooltipItem,
} from 'components/ContextMenuTooltip';
import { DropdownSection } from 'components/DropdownSection';

import { QuickEntityTile } from './QuickEntityTile';
import { QuickEntity } from './types';

interface QuickEntitySectionProps {
  title: string;
  entities: QuickEntity[];
  activeEntityId: string;
  getContextMenu: (entity: QuickEntity) => IContextMenuTooltipItem[];
  onEntityClick: (id: string, isActive?: boolean) => void;
  onEntityFavoriteToggle: (id: string, isFavorite: boolean) => void;
}

export const QuickEntitySection: FC<QuickEntitySectionProps> = memo(
  ({
    title,
    entities,
    activeEntityId,
    getContextMenu,
    onEntityClick,
    onEntityFavoriteToggle,
  }) => (
    <DropdownSection
      title={title}
      classNames={{
        content: 'grid grid-cols-[repeat(auto-fill,minmax(100px,1fr))] gap-1',
      }}
    >
      {entities.map((entity) => {
        return (
          <ContextMenuTooltip
            key={entity.id}
            trigger="contextMenu"
            items={getContextMenu(entity)}
            keyboard
          >
            <QuickEntityTile
              id={entity.id}
              title={entity.type}
              icon={entity.icon}
              isFavorite={entity.isFavorite}
              isActive={entity.id === activeEntityId}
              onClick={onEntityClick}
              onFavoriteToggle={onEntityFavoriteToggle}
            />
          </ContextMenuTooltip>
        );
      })}
    </DropdownSection>
  )
);

QuickEntitySection.displayName = 'QuickEntitySection';
